import styled, { css } from 'styled-components';

import { Link } from '../../ui-helpers';
import { theme, hideOverflowText } from '../../../styles';


export const ImageWrapper = styled.div`
  width: 22px;
  text-align: center;
  margin-right: 16px;
  vertical-align: text-top;
  display: flex;
  align-items: center;
  padding-bottom: 3px;

  ${({ collapsed }) => collapsed && css`margin-right: unset`};

  svg {
    margin: 0 auto;
  }
`;

export const Menu = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const MenuItem = styled.li`
  height: 50px;

  background-color: ${({ activeItem }) => activeItem && theme.colors.fontTangerine};
  font-weight: ${({ activeItem }) => activeItem && '500'};
  
  &:hover {
    background-color: ${({ activeItem }) =>
    activeItem
      ? theme.colors.fontTangerine
      : theme.colors.fontSilverPrimary}; 
  }
`;

export const MenuItemLink = styled(Link)`
  height: 50px;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  padding: 15px 30px;
  color: ${theme.colors.backgroundLightBlue};

  span {
   ${hideOverflowText}
  }

  ${({ collapsed }) => collapsed && css`justify-content: center`};

  &:focus,
  &:hover {
    text-decoration: none;
    color: ${theme.colors.backgroundLightBlue};  
  }
`;



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar-menu/styled-components.js